import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { featuredGuides } from '@/mocks/guides';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-grid-fill text-primary-500 text-xl"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900">OOPBuy</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your central knowledge hub for OOPBuy Spreadsheet systems. Learn, compare, and master data-driven buying decisions.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="#categories" className="hover:text-primary-500 transition-colors">Product Categories</a>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">More Categories</h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Featured Guides</h4>
            <ul className="space-y-2">
              {featuredGuides.slice(0, 5).map((guide) => (
                <li key={guide.title}>
                  <Link
                    to={guide.slug}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                  >
                    {guide.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheet Hub. All rights reserved. This is an informational website only.
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Visit Main Platform &rarr;
          </a>
        </div>
      </div>
    </footer>
  );
}